import axios from "axios";
import setupInterceptors from "./setupInterceptors.js";

const baseURL = process.env.REACT_APP_API_URL;

const bilAPI = axios.create({
  baseURL,
  // Fail fast instead of hanging the UI for the full 60s nginx timeout when
  // the backend is unresponsive.
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

setupInterceptors(bilAPI);

export default bilAPI;
